import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Caption } from '@primer/gatsby-theme-doctocat';
import { Flash, Text } from '@primer/components';
import { InfoIcon } from '@primer/styled-octicons';
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`To maintain configuration and state, whilst making the API easy to use, singletons have been employed. This section will go demonstrate the usage of this pattern within the SDK and provide guidance on its use for development.`}</p>
    <h2>{`Registration`}</h2>
    <p>{`To use register a singleton for use, first it needs a factory function binding to the `}<inlineCode parentName="p">{`Container`}</inlineCode>{` instance.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`this.singleton('myclass', function (app: ContainerInterface, config: Config) {
    return new MyClass();
});
`}</code></pre>
    <Caption mdxType="Caption">Binding a factory function to the abstract key 'myclass'</Caption>
    <p>{`The factory function takes two parameters, the `}<inlineCode parentName="p">{`Container`}</inlineCode>{` instance and an instance of the `}<inlineCode parentName="p">{`Config`}</inlineCode>{` bag. What is returned is known as the "Concrete" instance.`}</p>
    <p>{`The "abstract" is the key that the binding will be accessible by. This should be a string that is unique to this factory.`}</p>
    <Flash scheme="yellow" mdxType="Flash">
    <InfoIcon mr={1} mdxType="InfoIcon" />Binding an abstract with a non-unique name will overwrite the previous factory
    </Flash>
    <h2>{`Resolution`}</h2>
    <p>{`Retrieving an instance from the `}<inlineCode parentName="p">{`Container`}</inlineCode>{` is simple.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`this.resolve<MyClass>('myclass');
`}</code></pre>
    <Caption mdxType="Caption">Retrieving an instance of MyClass from the Container</Caption>
    <p>{`When a Concrete instance is returned, it is stored within the `}<inlineCode parentName="p">{`Container`}</inlineCode>{` against the abstract. The next time the `}<inlineCode parentName="p">{`resolve`}</inlineCode>{` method is run, it will retrieve the concrete instance from the store.`}</p>
    <h2>{`Resetting`}</h2>
    <p>{`It is sometimes necessary to refresh a concrete instance.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`this.resetInstance('myclass');
`}</code></pre>
    <Caption mdxType="Caption">Resetting 'myclass'</Caption>
    <p>{`Invoking `}<InlineCode mdxType="InlineCode">{`resetInstance`}</InlineCode>{` will clear the concrete instance from the store, and then invoke the associated factory.`}</p>
    <Flash mdxType="Flash">
    <InfoIcon mr={1} mdxType="InfoIcon" /><Text mdxType="Text">Don't confuse <InlineCode mdxType="InlineCode">resolveInstance</InlineCode> and <InlineCode mdxType="InlineCode">resolve</InlineCode>. <InlineCode mdxType="InlineCode">resolveInstance</InlineCode> is a state method which can be used to resolve the active container for static methods.</Text>
      <pre><code parentName="pre" {...{
          "className": "language-typescript"
        }}>{`static get MyClass(): MyClass {
    return this.resolveInstance()
        .resolve('myclass');
}
`}</code></pre>
      <Caption mdxType="Caption">Resolving 'myclass' statically</Caption>
    </Flash>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      